<template>
  <div class="modal-backdrop">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('deposit-profile') }}</h5>
          <button type="button" class="close" @click="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group">
              <label>{{ $t('amount') }} {{ $t('depositing-1').toLowerCase() }}</label>
              <input class="large" type="text" :placeholder="$t('amount') + ' ' + $t('depositing-1').toLowerCase()" v-model="payment.amount">
              <span class="error" v-if="errors.sum">{{ errors.sum[0] }}</span>
            </div>
            <div class="form-group">
              <a class="link-blue" @click="getInvoicePayment()">{{ $t('get-bill-for-deposit') }}</a>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">{{ $t('close') }}</button>
          <button type="button" class="btn btn-primary" @click="sendPayment">{{ $t('deposit') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: 'payment-modal',
  props: ['id'],
  data: function(){
    return{
      payment: {
        amount: '',
      },
      errors: [],
    }
  },
  methods: {
    close: function() {
      this.$emit('close');
    },
    sendPayment: function(){
      axios.post('sendPayment', this.payment).then(response => {
        var status = response.data.status;
        if (status) {
          window.location.href = response.data.link;
        }else{
          this.errors = response.data.errors;
        }
      });
    },
    getInvoicePayment: function(){
      axios.post('getInvoicePayment', this.payment).then(response => {
        var status = response.data.status;
        if (status) {
          this.errors = [];
          let link = document.createElement('a');
          link.href = response.data.link;
          link.setAttribute('download', response.data.filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }else{
          this.errors = response.data.errors;
        }
      });
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  position: relative;
  border-bottom: 1px solid #eeeeee;
  color: #000000;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
}

</style>